module.exports = __webpack_public_path__ + "img/blast-3.1b8d2746.jpg";